import Brain from "../../../lib/services/collision/brain";
import Puppy from "./puppy";
import PuppyNavigator from "./puppynavigator";
import { PuppyClips } from "./puppyclips";
import { PuppyPosture } from "./puppytypes";
import Bone from "../bone/bone";

export default class PuppyBrain extends Brain {
  private puppy: Puppy;
  private initialized = false;

  constructor(puppy: Puppy, navigator: PuppyNavigator) {
    super();
    this.puppy = puppy;
    this.attach(puppy, navigator);
  }

  initialize_spawn(
    x: number,
    y: number,
    z: number,
    yaw: number = 0
  ): void {
    this.puppy.transform.set_position(x, y, z);
    this.puppy.transform.set_rotation(0, yaw, 0);
    this.puppy.transform.update_matrix();

    this.puppy.shadow?.update_shadow(
      this.puppy.transform.position[0],
      this.puppy.transform.position[1],
      this.puppy.transform.position[2]
    );


    if ( this.puppy.animation_controller_gpu && this.navigator)
    {
      this.puppy_navigator.set_posture("sitting");
      this.puppy.animation_controller_gpu.playLoopByIndex(
        PuppyClips.Sitting_loop_1); 
    }

    this.initialized = true;
  }

  private get puppy_navigator(): PuppyNavigator {
  return this.navigator as PuppyNavigator;
}

  
  chase_bone(bone:Bone):void
  {
    this.puppy_navigator.move_to_point(
                        bone.transform.position,
                        "aggressive",
                        0.35
                      );
  }

  tick(delta_time: number): void 
  {
    if (!this.owner || !this.navigator || !this.puppy.runtime) return;
        this.navigator.tick(delta_time);

  }
}